export default __webpack_public_path__ + "static/media/lining1.6647baa1.jpeg";